module.exports = __webpack_public_path__ + "img/LiabilityReport.ceb4ce32.jpg";